import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      isSuccessful
      message
      data {
        token
        domainName
      }
    }
  }
`

export const WHOAMI = gql`
  query Whoami {
    whoami {
      isSuccessful
      message
      whoami {
        userId
        name
        email
        wsToken
        scopes
        companyId
        companyName
        accessType
        accessRight
      }
    }
  }
`

export const LOGOUT = gql`
  mutation Logout {
    logout {
      isSuccessful
    }
  }
`

// Axios
// import axios from 'axios'

// export const LOGIN = axios.post('http://localhost:5000/api/v1/auth/login', {
//   email: 'edev@mail.com',
//   password: '123123'
// })
// .then(function (token) {
//   // console.log(response);
//   return(token);
//     // this.tryingToLogIn = false;
//     // // Redirect to the originally requested page, or to the home page
//     // this.$router.push(
//     //   this.$route.query.redirectFrom || {
//     //     name: "default",
//     //   }
//     // );
// })
// .catch(function (error) {
//   return(error);
//   // console.log(error);
// });
